import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import { PasswordInput } from '@hid-galaxy-ui/galaxy-react';
import { getLabel } from '../../../utils/FormDataMappers';

const useInputStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    // maxWidth: theme.custom.inputs.maxWidth,
    // marginBottom: theme.spacing(5),
  },
}));

const InputPassword = (props) => {
  const classes = useInputStyles();
  const { field, form, value, required, label, hint, className, propsHasError = false } = props;
  const { name: fieldName, value: fieldValue } = field || {};
  const { errors, setFieldValue, touched } = form || {};
  const fieldError = fieldName && errors && errors[fieldName] ? errors[fieldName] : null;
  const hasError = Boolean(fieldError) || propsHasError;
  const helperText = fieldError || hint;
  const inputValue = fieldValue || value;

  const shouldDisplayError = () => touched[fieldName] && !!errors[fieldName];

  const handleChange = (event) => {
    const newValue = event.target.value;
    if (fieldName && setFieldValue) {
      // setFieldError(fieldName, undefined);
      setFieldValue(fieldName, newValue);
    } else if (onChange) {
      onChange(newValue);
    }
  };

  return (
    <div className={className}>
      <PasswordInput
        {...props}
        id={fieldName}
        name={fieldName}
        helperText={shouldDisplayError() ? helperText : undefined}
        isRequired={required}
        label={label}
        status={shouldDisplayError() ? 'error' : undefined}
        onChange={handleChange}
        inputProps={{ autocomplete: 'new-password' }}
      />
    </div>
  );
};

export default InputPassword;
